import { useTranslate } from 'react-polyglot';

import { ConfigurationIcon } from '@genially/icons';

import { useHostGameContext } from '../../../../HostGame.context';
import { useOpenSessionConfigModal } from '../../../../hooks/useOpenSessionConfigModal';
import { SidebarLink } from '../SidebarLink/SidebarLink';

export const SessionConfigSidebarLink = () => {
  const t = useTranslate();
  const { settingsSidebar } = useHostGameContext();
  const { openSessionConfigModal } = useOpenSessionConfigModal();

  const handleClick = () => {
    settingsSidebar.close();
    openSessionConfigModal();
  };

  return (
    <SidebarLink
      Icon={ConfigurationIcon}
      text={t('__new.play.shared.configuration')}
      onClick={handleClick}
    />
  );
};
